import React, { useEffect } from 'react'
import useForm from 'react-hook-form'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faHome, faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container,
  UncontrolledTooltip
} from 'reactstrap'
import PropTypes from 'prop-types'
import { fetchModel, openDeleteModelModal } from 'redux/actions/models'
import DependenciesList from 'components/Models/dependenciesList'
import ModelForm from 'components/Models/form'
import BackButton from 'components/BackButton'

const ModelDetail = ({ fetchModel, form, loading, history, match, openDeleteModelModal, hasDependencies }) => {
  const { register, reset } = useForm()

  useEffect(() => {
    fetchModel(match.params.id)
  }, [fetchModel, match])

  useEffect(() => {
    reset(form)
  }, [form, reset])

  const id = `model_${form.id}`
  return (
    <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
      <BackButton />
      <Row>
        <Col className="order-xl-1" xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="12">
                  <h3 className="mb-0">
                    <FontAwesomeIcon icon={faHome} className="mr-1"/> Detalle de Modelo<br/>
                    <Button
                      tag={Link}
                      color="primary"
                      to={`/admin/models/${match.params.id}/edit`}
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faPencilAlt} className="mr-2"/>
                      Editar Modelo
                    </Button>
                    {hasDependencies && (
                      <UncontrolledTooltip target={id}>
                        Este modelo no se puede eliminar por que tiene categorías asociadas a el.
                      </UncontrolledTooltip>
                    )}
                    <Button
                      color="warning"
                      disabled={hasDependencies}
                      onClick={() => openDeleteModelModal(form)}
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faTrash} className="mr-2"/>
                      Borrar Modelo
                      {hasDependencies && (
                        <FontAwesomeIcon
                          id={id}
                          icon={faInfoCircle}
                          className="ml-2"
                        />
                      )}
                    </Button>
                  </h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {loading && (
                <ReactLoading type="spinningBubbles" color="#000" height={30} width={30} className="mt-3" />
              )}
              <ModelForm
                readOnly
                loadingModel={loading}
                project={form.project}
                register={register}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <DependenciesList model={form} />
    </Container>
  )
}

const mapStateToProps = ({ models: { form, loadingModel }, modelCategories: { modelCategories } }) => ({
  form,
  hasDependencies: modelCategories.length > 0,
  loading: loadingModel,
})

const mapDispatchToProps = dispatch => ({
  fetchModel: id => dispatch(fetchModel(id)),
  openDeleteModelModal: model => dispatch(openDeleteModelModal({ model, source: 'detail' })),
})

ModelDetail.propTypes = {
  form: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    name: PropTypes.string,
    project: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
    })
  }),
  loading: PropTypes.bool,
  openDeleteModelModal: PropTypes.func.isRequired,
  fetchModel: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }).isRequired
  }).isRequired,
  hasDependencies: PropTypes.bool.isRequired
}

ModelDetail.defaultProps = {
  form: {
    description: '',
    name: '',
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModelDetail))
